import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { APIServiceService } from 'src/app/api/apiservice.service';
import { Appointment } from 'src/app/models/appointment.model';
import { Customer } from 'src/app/models/customer.model';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'ubc-customer-edit-form',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './customer-edit-form.component.html',
  styleUrl: './customer-edit-form.component.scss'
})
export class CustomerEditFormComponent {

  @Input() customer?: Customer
  customerForm: FormGroup
  @Output() cleared: EventEmitter<void> = new EventEmitter()
  @Output() customerCreated: EventEmitter<Customer> = new EventEmitter()

  constructor(
    private notificationsService: NotificationsService,
    private apiService: APIServiceService
  ){
    this.customerForm = new FormGroup({
      id: new FormControl(0),
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      tel: new FormControl('', Validators.required),
      notes: new FormControl('', Validators.maxLength(255))
    })
  }

  ngOnInit(){
    this.populateCustomerForm()
  }

  populateCustomerForm(){
    const customerData =  this.customer  || { id: undefined, firstName: undefined, lastName: undefined, tel: undefined, email: undefined, billingAddress1: undefined, billingAddress2: undefined, billingCity: undefined, billingPostcode: undefined, billingTown: undefined, notes: undefined }
    this.customerForm.patchValue(customerData)

    console.log(this.customerForm.value)
  }

  async customerFormSubmit(){

    try {
    if(this.customerForm.value.id){
      const updated = await this.apiService.customer.update(this.customerForm.value)
      this.notificationsService.add("success", "Customer Details Updated", `${this.customerForm.value.firstName} ${this.customerForm.value.lastName} details were sucessfully updated`)
    } else {
      const customer = new Customer().deserialize(this.customerForm.value)
      const created = await this.apiService.customer.create(customer)
      this.notificationsService.add("success", "Customer Created", `${this.customerForm.value.firstName} ${this.customerForm.value.lastName} was created`)
      const newCustomer = new Customer().deserialize(created.data)
      this.customerCreated.emit(newCustomer)
    }
    } catch(e){
      throw e
    }
  }

  changeCustomerClicked(){
    console.log("Click")
    this.cleared.emit()
  }

}
